import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"],\"variable\":\"--font-inter\"}],\"variableName\":\"fontInter\"}");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/opt/atlassian/pipelines/agent/build/node_modules/react-hot-toast/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "/opt/atlassian/pipelines/agent/build/src/app/provider.tsx");
